import React from 'react';
import { array, func, shape, string } from 'prop-types';

import CSS from './styles.css';

import InteractiveCircle from 'Shared/InteractiveCircle';
import { Highlight as HLIcon } from 'Shared/Icons';


const HighlightOptionsViews = ({ addHighlight, dispatch, label, markers, selectedHighlight }) => {
  const { id:highlightId } = selectedHighlight;

  return (
    <section className={ CSS['container'] }>
      <div className={ CSS['marker__list'] }>
        <div className={ CSS['radio-list'] }>
          { markers.map((marker, key) => {
              return (
                <InteractiveCircle key={ key }
                  marker={ marker }
                  selectedHighlight={ selectedHighlight }
                  dispatch={ dispatch } />
              );
            })
          }
        </div>

        <div className={ CSS['radio-label'] }>
          { label }
        </div>
      </div>

      { highlightId
        ? null
        : <button className={ CSS['add-highlight'] } onClick={ addHighlight }>
            <HLIcon fill="#ffffff" />
            <span className={ CSS['add-highlight__text'] }>Add Highlight</span>
          </button>
      }

    </section>
  );
};

HighlightOptionsViews.propTypes = {
  label: string,
  dispatch: func,
  markers: array,
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    highlightId: string,
    noteText: string
  })
};


export default HighlightOptionsViews;
